import * as React from 'react';

import { Page, PageContent, PageHeader } from '../components/common';

class FourOhFourPage extends React.Component<{}, {}> {
	render() {
		return (
			<Page className="404 text-center" title="Page not found">
				<PageContent>
					<PageHeader isCentered={true}>
						<h1 className="display-1 text-secondary">404</h1>
						<h2 className="text-secondary mb-0">Page not found</h2>
					</PageHeader>
					<p className="mt-4">Sorry, I'm not sure how you got here but this place doesn't exist.</p>
				</PageContent>
			</Page>
		);
	}
}

export default FourOhFourPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/404Page.tsx